import { Injectable } from '@angular/core';
import { CommonService } from '../services/common.service';

@Injectable({
  providedIn: 'root'
})
export class ItemListTableService {

  constructor(public _commonService: CommonService) { }


  tableFilter(originalData, customTableData, tableId, receivedFilter, isCustomTableData, filterArray) {

    let filterDatafrom = originalData;
    let isFirst = true;

    if (filterDatafrom) {
      receivedFilter.forEach(e => {
        const filterBy = e.jsonKey,
          filterDataBy = e.innervalue.filter(x => x.checked === true);
        if (filterDataBy.length > 0) {
          if (!isFirst) {
            filterDatafrom = customTableData;
          }
          const filteredData = [];
          if (tableId === 'recentTransfers' || tableId === 'offlineTransfers') {
            filterDataBy.forEach(element => {
              filterDatafrom.filter(x => {
                if (x[filterBy] === element.id) {
                  filteredData.push(x);
                }
              });

            });
          } else if(tableId === 'recentInTransit'){
            filterDataBy.forEach(element => {
              filterDatafrom.filter(x => {
                if (x[filterBy] === element.value) {
                  filteredData.push(x);
                }
              });

            });
          } else if (filterBy === 'dropShip') {
            filterDataBy.forEach(element => {
              filterDatafrom.filter(x => {
                if (x[filterBy] === element.filterValue) {
                  filteredData.push(x);
                }
              });

            });
          } else {
            filterDataBy.forEach(element => {
              filterDatafrom.filter(x => {
                if (x[filterBy] === element.value) {
                  filteredData.push(x);
                }
              });

            });
          }
          isCustomTableData = true;
          if (filterDataBy.length > 0 && isFirst) {
            customTableData = filteredData;
            isFirst = false;
          } else if (filterDataBy.length > 0 && !isFirst) {
            customTableData = filteredData;
          }

          const topItem = document.getElementsByClassName('table-row')[0];
          if (topItem && this._commonService.iconShow) {
            topItem.scrollIntoView(({ behavior: 'smooth', block: 'nearest', inline: 'start' }));
          }

        }

      });


      if (receivedFilter.filter(ele => ele.innervalue.every(x => x.checked === false)).length === filterArray.length) {
        isCustomTableData = false;
      }

      const data = isCustomTableData ? customTableData : originalData;

      this._commonService.iconShow = receivedFilter.some(
        ele => ele.innervalue.some(x => x.checked === true) ||
               (ele.filterType === 'daterange' && ele.fromDate != null));


     return data;
    }
  }
}
